import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeliveryDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"delivery_dining"}/>
}
